import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { Skeleton, Select as MuiSelect } from '@mui/material';
import {
	ColoredInStocksIcon
} from 'ui-component/custom-icons/icons';

// ✅ Clear
const ChangeStockModal = ({ openChangestockPopup, productDetails, handleClose, handleSave }) => {
	const [stock, setStock] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [selectedColorId, setSelectedColorId] = useState(null);
	const [selectedWarehouseId, setSelectedWarehouseId] = useState(null);
	const [selectedWarehouse, setSelectedWarehouse] = useState(null);
	const [disable, setDisable] = useState(true);
	const [reasonValue, setReasonValue] = useState(null);
	const [colorLists, setColorLists] = useState([]);
	const [warehouseList, setWarehouseList] = useState([]);
	const [isColorLoading, setIsColorLoading] = useState(true);


	const loadProductColorsWithStocks = () => {
		setIsColorLoading(true)
		api.getProductsColorsWithStocks(productDetails?.id).then((res) => {
            if (res?.status) {
                const tempList = res.data.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setColorLists(tempList);
			}
			setIsColorLoading(false);
		});
	};

	useEffect(() => {
		loadProductColorsWithStocks()
	}, [])


	useEffect(() => {
			setDisable(false);
	}, [stock]);

	const handleIncrease = () => {
		const currentStock = (stock == '') ? 0 : stock;
		setStock(parseInt(currentStock) + 1);
	};
	const handleDecrease = () => {
		if ((stock + selectedWarehouse?.free_stock_qty)  > 0) {
			setStock(stock - 1);
		}
	};
	const updaterowCounts = (value) => {
		const intValue = parseInt(value) || 0;
		setStock(intValue);
	};

	useEffect(() => {

        api.getSelectOptionsListWithId('warehouses_with_stocks', productDetails?.id).then((res) => {
            if (res?.status) {
                const tempList = res.data.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setWarehouseList(tempList);
			}
			setIsLoading(false);
        });
	}, []);

	useEffect(() => { }, [openChangestockPopup]);
	const onSubmit = () => {
		const data = {
			stock_qty: stock,
			warehouse_id: selectedWarehouseId,
			color_id: selectedColorId,
			product_id: productDetails?.id,
			reason: reasonValue
		};
		handleSave(data);
		setDisable(true);
	};

	const disablepopup = () => {
		handleClose();
	};
	return (
		<>
			<Modal show={openChangestockPopup} onHide={disablepopup} size="md" centered>
				<Modal.Body>
					<div className="p-2">
						<div className="mb-2 ml-0 pl-0">
							<div className="row">
								<div className="col-12 text-center mb-3">
									<div className="d-flex justify-content-center">
										<ColoredInStocksIcon width='60px' height='60px' />
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12 text-center">
									<div className="d-flex justify-content-center">
										<h2 className="h4 mb-0 font-weight-bold">Stocks</h2>
									</div>
								</div>
							</div>
							<div className="row" style={{ marginTop: '15px' }}>
								<div className="col-12 text-center mb-3">
									Manage stocks for product <br />{productDetails?.product_name}.
								</div>
							</div>
							<button className="btn modal-close-icon" onClick={handleClose}>
								<svg
									id="Component_127_1"
									height="16"
									width="16"
									data-name="Component 127 – 1"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 19.295 19.289"
								>
									<path
										id="Icon_ionic-ios-close"
										data-name="Icon ionic-ios-close"
										d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
										transform="translate(-11.285 -11.289)"
									/>
								</svg>
							</button>
						</div>
						<div className="foundListPopup">
							<div className="row align-items-top">
								<div className="col-12">
									<div className="row">
										<div className="form-group col-md-12">
											<label className="">Location</label>
											{
												isLoading ? (
													<Skeleton variant="rectangular" width={'100%'} height={40} style={{ borderRadius: '8px' }} />
												) : (
													<Select
														options={warehouseList}
														className="rs-container"
														classNamePrefix="rs"
														placeholder="Select or type..."
														isMulti={false}
														formatOptionLabel={({ label, optionAttribute }) => (
															<div dangerouslySetInnerHTML={{ __html: label }}></div>
														)}
														style={{ border: '1px solid #000' }}
														onChange={(e) => {
															setSelectedWarehouseId(e?.value);
															setSelectedWarehouse(e);
														}}
													/>
												)
											}
											
										</div>
									</div>
									<div className="row">
										<div className="form-group col-12 col-md-6">
											<label className="">Color</label>
											
											{
												isColorLoading ? (
													<Skeleton variant="rectangular" width={'100%'} height={40} style={{ borderRadius: '8px' }} />
												) : (
													<Select
														options={colorLists}
														className="rs-container"
														classNamePrefix="rs"
														placeholder="Select or type..."
														isMulti={false}
														formatOptionLabel={({ label, optionAttribute }) => (
															<div dangerouslySetInnerHTML={{ __html: label }}></div>
														)}
														style={{ border: '1px solid #000' }}
														onChange={(e) => {
															setSelectedColorId(e?.value);
														}}
													/>
												)
											}
										</div>
										<div className="form-group col-12 col-md-6">
											<label className="">Change Stock</label>
											{
												isLoading ? (
													<Skeleton variant="rectangular" width={'100%'} height={40} style={{ borderRadius: '8px' }} />
												) : (

													<div>
														<div className='btn-group' style={{ width: '100%' }}>
															<button
																className={`btn btn-default btn-sm btn-left ${selectedWarehouseId ? '' : 'disabled'}`}
																style={{ height: '36px' }}
																onClick={() => {
																	if (selectedWarehouseId) {
																		handleDecrease()
																	}
																}}
															>
																<FaMinus />
															</button>
															<input
																type="number"
																value={stock}
																className={`product-amount-field ${selectedWarehouseId ? '' : 'disabled'}`}
																onChange={(e) => {
																	const cleanedValue = e.target.value.replace(/[^0-9]/g, '');
																	updaterowCounts(cleanedValue);
																}}
																onFocus={(event) => {
																	if (event.target.value == '0.00' || event.target.value == '0') {

																		updaterowCounts('')
																	}
																	event.target.select();
																}}
																style={{ width: '100%' }}
																disabled={selectedWarehouseId ? false : true}
																
																	autoComplete={'off'}
																	onClick={(e) => {
																		if (e.target.value === '0' || e.target.value === '0.00') {
																			
																			updaterowCounts('')
																		}
																	}}
																	onBlur={(e) => {
																		if (e.target.value === '' || e.target.value === '0' || e.target.value === '0.00') {
																			updaterowCounts('0');
																		}
																	}}
															/>
															<button
																className={`btn btn-default btn-sm btn-right ${selectedWarehouseId ? '' : 'disabled'}`}
																style={{ height: '36px' }}
																onClick={() => {
																	if (selectedWarehouseId) {
																		handleIncrease()
																	}
																}}
															>
																<FaPlus />
															</button>
														</div>
													</div>
												)
											}

										</div>
									</div>
									<div className="row">
										<div className="form-group col-md-12">
											<label className="">Reason</label>
											{	
												isLoading ? (
													<Skeleton variant="rectangular" width={'100%'} height={120} style={{ borderRadius: '8px' }} />
												) : (
													<textarea
														className='form-control'
														rows="4"
														value={reasonValue}
														onChange={(e) => setReasonValue(e.target.value)}
														style={{ resize: 'none' }}
													/>
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="btnarea">
							{	
								isLoading ? (
									<div style={{ width: '100px' }}>
									<Skeleton variant="rectangular" width={'100%'} height={40} style={{ borderRadius: '8px' }} />
									</div>
								) : (
									<button disabled={disable} onClick={onSubmit} className="btn btn-main">
										{stock === 0 ? (
											'No Stock Change'
										) : (
											<div>
												Save new stock level of <span>{stock + selectedWarehouse?.free_stock_qty}</span> pieces
											</div>
										)}
									</button>
								)
							}
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default ChangeStockModal;
